// # orderString
// {
//     "uniqueid": "78D344C4",
//     "alias": "B6",
//     "orderitems": [
//         {
//             "uniqueid": "1708915048880",
//             "name": "Latte ลาเต้ (hot ร้อน)",
//             "quantity": 2,
//             "subitemid": 411077,
//             "price": 70,
//             "taglist": [
//                 "printer2"
//             ]
//         },
//         {
//             "uniqueid": "1708915112408",
//             "name": "Fruit salad ฟรุตสลัด (corn.+yg คอนเฟลค+โยเกิร์ต)",
//             "quantity": 1,
//             "subitemid": 374789,
//             "price": 130,
//             "taglist": [
//                 "printer2"
//             ]
//         }
//     ]
// }

// # cloud2
// {
//     "uniqueid": "9F23E987",
//     "customerid": 7216,
//     "username": "maijung (m)",
//     "table": 7,
//     "imei": "86feb8780938b213",
//     "deviceId": "8b213",
//     "isRetry": false,
//     "alias": "โต๊ะ 7",
//     "jobId": 0,
//     "useZone": false,
//     "appCodeVersion": 115,
//     "employeeId": 38675,
//     "employeeName": "maijung",
//     "customercount": 2,
//     "datetime": "2025-10-15T21:51:31.368+0700",
//     "handshake": true,
//     "orderitems": [
//         {
//             "uniqueid": "1760539882971",
//             "name": "01.Asahi Nama(แก้ว) 335ml",
//             "quantity": 2,
//             "subitemid": 1289647,
//             "price": 140,
//             "toPrinter": 99,
//             "bill": 1,
//             "isDivider": false,
//             "isTogo": false,
//             "taglist": [
//                 "printer1"
//             ]
//         }
//     ],
//     "comments": "",
//     "read": 2,
//     "isVoid": false,
//     "by": "maijung",
//     "mode": 1,
//     "fullAlias": "Table 7"
// }

// # coverted
//  {
//     "timestamp": "2025-10-16T06:22:47.138Z",
//     "employee": {
//       "employeeId": "unknown",
//       "name": "chai"
//     },
//     "jobId": "1760595767138",
//     "items": [
//       {
//         "qty": 1,
//         "subItemId": 219055,
//         "name": "กาแฟดำ",
//         "uuid": "3802#1760595764166",
//         "price": 30,
//         "tax": [
//           2,
//           7
//         ],
//         "extPrice": 30
//       }
//     ],
//     "table": "A20",
//     "guests": 2,
//     "action": "ADD",
//     "channel": "cashier",
//     "type": "table"
//   },

import { JobMode } from "~/interface/Job";
import { JobAction } from "~/interface/Job";
import dayjs from "dayjs";
import JobBuilder from "./JobBuilderV1";

export default class AdapterMobileV1 {
  fromCloudToJobchain(orderString: string) {


    const jobV1Store = usePosJobsStore();
    const orderData = JSON.parse(orderString);

    const table = orderData.alias.replace("โต๊ะ ", "T").replace("Table ", "T");
    const items = orderData.orderitems.map((item: any) => {

      const toppings = item.toppings?.map((topping: any) => {
        return {
          toppingId: topping.toppingid,
          name: topping.name,
          price: topping.price,
          qty: topping.quantity,
          quantity: topping.quantity,
        };
      });


      let _comment = '';
      if (item.isTogo) {
        _comment = '<<< TAKE AWAY >>> ';
      }

      if (item.comments) {
        _comment += item.comments;
      }

      // Quantity guard — the mobile client can send a non-positive quantity when
      // the employee edits the number field and leaves it empty / 0 / negative.
      // A qty-0 line is UNKILLABLE downstream: PAY/VOID build json2 as
      // `quantity * -1` → `0`, and JobchainV1_1.voidItem only decrements when
      // `qtyToVoid < 0`, so the line survives every void and every payment and
      // pins the table open forever (see T16 / "Avocado Toast ( VG )" incident,
      // 36 jobs across 2 days trying to clear one 0-qty line). Normalise on
      // receive — this is the single funnel for both mobile paths
      // (pos.mobile-v1 and pos.job-gateway), so nothing else has to defend.
      const _quantity = Number(item.quantity) > 0 ? Number(item.quantity) : 1;

      return {
        ...item,
        quantity: _quantity,
        qty: _quantity,
        subItemId: item.subitemid,
        name: item.name,
        uuid: item.uniqueid,
        price: item.price,
        comments: _comment,
        toppings: toppings || [],
        // tax : item.taglist,
        // extPrice : item.price * item.quantity
      };
    });
    const guests = orderData.customercount;
    const isOpeningTable = jobV1Store.tables[table]?.items?.length > 0 ? false : true;

    // Item-level default discount: the mobile order arrives with no discount,
    // and this adapter bypasses OrderBuilder — so stamp `discountrequest` on each
    // line HERE (same shared mapper the cart uses) before the job payload is
    // built. JobchainV1 normalises it to `discountRequest` on replay, so a
    // mobile order gets the same auto-discount a cashier order does.
    const withDiscount = usePosProductsStore().applyDefaultDiscount(items)

    // Combo menu: expand HERE — before building the job payload — so the mobile
    // order's job.json carries the "(W) " child lines for BOTH kitchen print and
    // table replay. Legacy Android never expands, so the cashier does it on
    // receive. Reused by pos.mobile-v1 and pos.job-gateway (Java client).
    // Discount first, then expand — free "(W) " children stay undiscounted.
    orderData.orderitems = usePosProductComboSetStore().expandItems(withDiscount)

    const jobBuilder: any = new JobBuilder()
      .withTableAlias(orderData.alias)
      .withTableUuid(orderData.table)
      .withOrderJson(orderData)
      .withActionType(JobAction.ADD)
      .withSource('m')
      .withEmployee({
        employeeId: orderData.employeeId || orderData.by || orderData.username  || 'mobile',
        name: orderData.employeeName || orderData.by || orderData.username || 'mobile',
      })
      .withPrint(true)
      .withNote(orderData.comments || "")
      .withMode(JobMode.TABLE)
      .withIsOpeningTable(isOpeningTable)
      .withGuests(guests)
      .withJobIdAndTimestamp(dayjs(orderData.datetime).toISOString())
      .withCustom( {
        comments : orderData.comments || null
      })
      .build();

    // jobId must identify the ORDER, not the send attempt. build() derives it from
    // `datetime`, which the phone re-stamps on every retry while keeping `uniqueid`
    // (jobMobileOrder.java:111) — so four taps of Retry on ONE order produced four
    // jobIds, four jobchain nodes and four kitchen slips. Keying on `uniqueid`
    // instead lets the set() in pos.jobs.add() collapse retries onto one node, and
    // makes the key reproducible: pos.mobile-v1 rebuilds this exact string to ask
    // "already taken?" with a single lookup instead of scanning the chain.
    // `timestamp` deliberately stays on `datetime` — replay order and the printed
    // slip read it. Note pos.job-gateway overrides jobId again after this call.
    if (orderData.uniqueid) {
      jobBuilder.jobId = `${orderData.uniqueid}__${jobBuilder.alias}`
    }

    return jobBuilder;
  }
}
